export enum VisibilityOpt {
  IS = 'is',
  IS_NOT = 'isNot',
}

export type ThemeImageKeys =
// Landing page
  'landingCoverImage' |
// Home page
  'circleCardBackground' |
// UnavowedPopup
  'unavowedPopupImage' |
// welcome animation custom image
  'welcomeTriggerImage'|
  // loyaltyPageBanner1
  'loyaltyPageCashbackBanner'|
  // loyaltyPageBanner2
  'loyaltyPageGiftBanner'|
  // loyaltyPage Hero section Background Image
  'loyaltyPageHeroBG'|
  // loyaltyPage Hero ribbon icon
  'loyaltyPageHeroRibbon'|
  // Loyalty page POS desktop BG
  'loyaltyPagePosDesktopBG'|
  // Loyalty page POS mobile BG
  'loyaltyPagePosMobileBG'|
  // Loyalty page POS congrats card
  'loyaltyPagePosCongratsCard'

export type ThemeSvgKeys =
// Tabs icons
  'homeTab' |
  'missionsTab' |
  'gameTab' |
  'redeemTab'|
  'liveTab' |
  'levelsTab'

export enum LauncherPositions {
  top = 'top',
  topRight = 'topRight',
  right = 'right',
  bottomRight = 'bottomRight',
  bottom = 'bottom',
  bottomLeft = 'bottomLeft',
  left = 'left',
  topLeft = 'topLeft'
}

export enum LauncherTypes {
  bar = 'bar',
  floatingIcon = 'floatingIcon',
}

export enum AppModes {
  dark = 'dark',
  light = 'light',
}
